export default "__VITE_ASSET__D0wWz57A__"